import styled from 'styled-components';
import { Icon, Tooltip } from '@studio/legacy-components';

export const QualifiedIcon = styled(Icon)`
  font-size: var(--medium-large);
`;

export const URLItemWrapper = styled.li`
  align-items: center;
  display: flex;
  gap: 8px;
  list-style: none;

  ${QualifiedIcon} {
    color: var(--dark-resting);
    ${({ $qualified, $installed }) =>
      $qualified &&
      `
        color: ${$installed ? 'var(--cutecumber)' : 'var(--rubber-ducky)'};
    `};
  }
`;

export const URLLabel = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 95%;
`;

export const URLTooltip = styled(Tooltip)`
  // TODO: this should be in Tooltip <Wrapper> default styles. It's added here in order to avoid
  // visual regression in other places that we should work separately.
  display: inline-flex;
`;
